export default __webpack_public_path__ + "static/media/reward_right.d8039f48.png";